import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionTitle from './SectionTitle';
import EventsBox from './EventsBox';
import ComingSoonTag from './ComingSoonTag';

type Event = {
    id: number;
    title: string;
    image: string;
    venue: string;
    date: string;
    time: string;
    price: number;
    isFreeOfCharge: boolean;
};

type EventsSectionProps = {
    title: string;
    events: Event[];
    seeAllLink?: string;
    disabled?: boolean;
};

const EventsSection: React.FC<EventsSectionProps> = ({ title, events, seeAllLink, disabled = false }) => (
    <Box
        sx={{
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            px: { xs: 2, sm: 3, md: 4 },
            mt: 4,
            mb: 4,
            opacity: disabled ? 0.4 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            position: 'relative',
        }}
    >
        {disabled && (
            <ComingSoonTag 
                variant="box" 
                size="large"
                position="absolute"
                absolutePosition={{
                    top: '50%',
                    left: '50%'
                }}
                sx={{ 
                    zIndex: 1,
                    transform: 'translate(-50%, -50%)'
                }}
            />
        )}
        <SectionTitle title={title} seeAllLink={seeAllLink} disabled={disabled} />
        {events.length === 0 ? (
            <Typography align="center" variant="body1" color="text.secondary" mt={2}>
                No events available.
            </Typography>
        ) : (
            <EventsBox events={events} />
        )}
    </Box>
);

export default EventsSection;
